<div class="container-fluid mt-3">
  <div class="row column-mobile-reverse">
    <div class="col-md-5">
      <app-new-products></app-new-products>
    </div>
    <div class="col-md-7">
      <div class="d-flex justify-content-md-end sort-by-responsive">
        <ul class="list-inline mb-0 d-inline-flex align-items-center d-flex">
          <li class="list-inline-item f-small ml-xl-3 text-uppercase">
            View
          </li>
          <li class="list-inline-item">
            <div class="form-group mb-0 pos">
              <select class="form-control dr-list new-select-box" id="sel1" (change)="changePerPage($event)">
                <option value="30" [selected]="queryParams && queryParams.perPage && queryParams.perPage == 30">30 items
                </option>
                <option value="50" [selected]="queryParams && queryParams.perPage && queryParams.perPage == 50">50 items
                </option>
                <option value="100" [selected]="queryParams && queryParams.perPage && queryParams.perPage == 100">100
                  items</option>
                <option value="500" [selected]="queryParams && queryParams.perPage && queryParams.perPage == 500">500
                  items</option>
              </select>
            </div>
          </li>
          <!-- <li class="list-inline-item f-small ml-xl-4" *ngIf="helperService.isSubscribed(profileData, 'plus-plan') || helperService.isSubscribed(profileData, 'premium-plan')">
              <div class="doller-box d-flex align-items-center justify-content-center">
                <p class="sort m-0 d-flex align-items-center justify-content-center" (click)="listPshow = !listPshow"
                  [ngClass]="{'active': listPshow}">
                  <span [ngClass]="{'active': listPshow}">$</span>
                  <span [ngClass]="{'Noactive': !listPshow}">$</span>
                  <span [ngClass]="{'Noactive': !listPshow}" class="cross-line">/</span>
                </p>
              </div>
            </li> -->
          <li class="list-inline-item f-small ml-xl-4 text-uppercase">
            Sort By:
          </li>
          <li class="list-inline-item">
            <div class="form-group mb-0">
              <select class="form-control dr-list new-select-box" id="sel1" (change)="sortBy($event)">
                <option value="default" [selected]="queryParams && queryParams.sortBy == 'default'">Newest (default)
                </option>
                <option value="price_low_to_high"
                  [selected]="queryParams && queryParams.sortBy && queryParams.sortBy == 'price_low_to_high'">Price low
                  to high</option>
                <option value="price_high_to_low"
                  [selected]="queryParams && queryParams.sortBy && queryParams.sortBy == 'price_high_to_low'">Price high
                  to low</option>
                <option value="weight_low_to_high"
                  [selected]="queryParams && queryParams.sortBy && queryParams.sortBy == 'weight_low_to_high'">Weight
                  Low
                  to High</option>
                <option value="weight_high_to_low"
                  [selected]="queryParams && queryParams.sortBy && queryParams.sortBy == 'weight_high_to_low'">Weight
                  High
                  to Low</option>
              </select>
            </div>
          </li>

          <li class="ml-xl-4">
            <a (click)="downloadAsPDF()" style="cursor: pointer;">
              <img src="/assets/img/download-icon.svg" alt="Download" width="30px" />
            </a>
          </li>

          <li class="ml-xl-4 grid-icon-style">
            <a class="cp" *ngIf="!showFirstIcon" (click)="toggleIcon()">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M14 5.6C14 5.03995 14 4.75992 14.109 4.54601C14.2049 4.35785 14.3578 4.20487 14.546 4.10899C14.7599 4 15.0399 4 15.6 4H18.4C18.9601 4 19.2401 4 19.454 4.10899C19.6422 4.20487 19.7951 4.35785 19.891 4.54601C20 4.75992 20 5.03995 20 5.6V8.4C20 8.96005 20 9.24008 19.891 9.45399C19.7951 9.64215 19.6422 9.79513 19.454 9.89101C19.2401 10 18.9601 10 18.4 10H15.6C15.0399 10 14.7599 10 14.546 9.89101C14.3578 9.79513 14.2049 9.64215 14.109 9.45399C14 9.24008 14 8.96005 14 8.4V5.6Z"
                    stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path
                    d="M4 5.6C4 5.03995 4 4.75992 4.10899 4.54601C4.20487 4.35785 4.35785 4.20487 4.54601 4.10899C4.75992 4 5.03995 4 5.6 4H8.4C8.96005 4 9.24008 4 9.45399 4.10899C9.64215 4.20487 9.79513 4.35785 9.89101 4.54601C10 4.75992 10 5.03995 10 5.6V8.4C10 8.96005 10 9.24008 9.89101 9.45399C9.79513 9.64215 9.64215 9.79513 9.45399 9.89101C9.24008 10 8.96005 10 8.4 10H5.6C5.03995 10 4.75992 10 4.54601 9.89101C4.35785 9.79513 4.20487 9.64215 4.10899 9.45399C4 9.24008 4 8.96005 4 8.4V5.6Z"
                    stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path
                    d="M4 15.6C4 15.0399 4 14.7599 4.10899 14.546C4.20487 14.3578 4.35785 14.2049 4.54601 14.109C4.75992 14 5.03995 14 5.6 14H8.4C8.96005 14 9.24008 14 9.45399 14.109C9.64215 14.2049 9.79513 14.3578 9.89101 14.546C10 14.7599 10 15.0399 10 15.6V18.4C10 18.9601 10 19.2401 9.89101 19.454C9.79513 19.6422 9.64215 19.7951 9.45399 19.891C9.24008 20 8.96005 20 8.4 20H5.6C5.03995 20 4.75992 20 4.54601 19.891C4.35785 19.7951 4.20487 19.6422 4.10899 19.454C4 19.2401 4 18.9601 4 18.4V15.6Z"
                    stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path
                    d="M14 15.6C14 15.0399 14 14.7599 14.109 14.546C14.2049 14.3578 14.3578 14.2049 14.546 14.109C14.7599 14 15.0399 14 15.6 14H18.4C18.9601 14 19.2401 14 19.454 14.109C19.6422 14.2049 19.7951 14.3578 19.891 14.546C20 14.7599 20 15.0399 20 15.6V18.4C20 18.9601 20 19.2401 19.891 19.454C19.7951 19.6422 19.6422 19.7951 19.454 19.891C19.2401 20 18.9601 20 18.4 20H15.6C15.0399 20 14.7599 20 14.546 19.891C14.3578 19.7951 14.2049 19.6422 14.109 19.454C14 19.2401 14 18.9601 14 18.4V15.6Z"
                    stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </g>
              </svg>
            </a>
            <a class="cp" *ngIf="showFirstIcon" (click)="toggleIcon()">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M8 6.00067L21 6.00139M8 12.0007L21 12.0015M8 18.0007L21 18.0015M3.5 6H3.51M3.5 12H3.51M3.5 18H3.51M4 6C4 6.27614 3.77614 6.5 3.5 6.5C3.22386 6.5 3 6.27614 3 6C3 5.72386 3.22386 5.5 3.5 5.5C3.77614 5.5 4 5.72386 4 6ZM4 12C4 12.2761 3.77614 12.5 3.5 12.5C3.22386 12.5 3 12.2761 3 12C3 11.7239 3.22386 11.5 3.5 11.5C3.77614 11.5 4 11.7239 4 12ZM4 18C4 18.2761 3.77614 18.5 3.5 18.5C3.22386 18.5 3 18.2761 3 18C3 17.7239 3.22386 17.5 3.5 17.5C3.77614 17.5 4 17.7239 4 18Z"
                    stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </g>
              </svg>
            </a>
          </li>

        </ul>
      </div>
    </div>

  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="pbb-line"></div>
    </div>
  </div>
</div>

<!--  -->
<section class="mt-3 mb-5">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-4 col-lg-3">
        <app-wheel-filters [showFilters]="showFilters" [filters]="filters" (filterSelected)="onFilterSelections($event)"
          (onClear)="onClear($event)" (onhideFilters)="onhideFilters()"></app-wheel-filters>
      </div>
      <div class="col-md-8 col-lg-9 list-reviews-tab ">

        <div class="row m-0" *ngIf="searchByVehicle">
          <div class="d-flex align-items-center w-100">
            <img src="{{bodyImage}}" width="150px" />
            <h3 class="mb-0 ml-0 ml-sm-4 text-capitalize text-font-reduced"> Wheels For {{ queryParams.year }} {{ queryParams.make }} {{
              queryParams.model }}</h3>
          </div>
        </div>

        <div class="d-flex flex-row justify-content-between flex-wrap align-items-center border-btm">
          <div class="accessories-tab new-tabs-style mb-0">
            <ul class="nav nav-tabs nav-justified search-nav-tabs self-tabs" *ngIf="searchByVehicle">
              <li class="nav-item">
                <a class="nav-link" [class.active]="activeDiameter == (+diameter - 1)" data-toggle="tab" href="#home"
                  (click)="getWheelsByDiameter(+diameter - 1)">{{+diameter - 1}}″(-1)</a>
              </li>
              <li class="nav-item">
                <a class="nav-link active" [class.active]="activeDiameter == (diameter) || !activeDiameter"
                  data-toggle="tab" href="#menu1" (click)="getWheelsByDiameter(diameter)">{{diameter}}″(OEM)</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [class.active]="activeDiameter == +diameter + 1" data-toggle="tab" href="#menu2"
                  (click)="getWheelsByDiameter(+diameter + 1)">{{+diameter + 1}}″(+1)</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [class.active]="activeDiameter == +diameter + 2" data-toggle="tab" href="#menu3"
                  (click)="getWheelsByDiameter(+diameter + 2)">{{+diameter + 2}}″(+2)</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [class.active]="activeDiameter == +diameter + 3" data-toggle="tab" href="#menu3"
                  (click)="getWheelsByDiameter(+diameter + 3)">{{+diameter + 3}}″(+3)</a>
              </li>
            </ul>
          </div>

          <span class="d-none d-lg-block text-right"  style="font-size: 10px;">
            Showing {{per_page}} items
        </span>
          
        </div>

        <span class="d-lg-none d-flex"  style="font-size: 10px;">
          Showing {{per_page}} items
      </span>


        <!-- <div class="row f-light listing-list hide-small mb-5">
          <div class="col-md-5 d-flex justify-content-between">
            <ul class="list-inline mb-0 d-inline-flex align-items-center">
              <li class="list-inline-item f-small font-400">
                Show {{ products?.length }} Wheels
              </li>
            </ul>
            <div class="d-flex hide-border align-items-center">
              <input type="checkbox" (change)=showOffers($event) [checked]="queryParams && queryParams.clearance && queryParams.clearance" />
              <p class="mb-0 bold f-small">Show Offer</p>
            </div>
          </div>
          <div class="col-md-7">
            <ul class="list-inline mb-0 d-inline-flex align-items-center">
              <li class="list-inline-item f-small ml-xl-3">
                Show
              </li>
              <li class="list-inline-item">
                <div class="form-group mb-0">
                  <select class="form-control dr-list" id="sel1" (change)="changePerPage($event)">
                    <option value="30" [selected]="queryParams && queryParams.perPage && queryParams.perPage == 30">30 items</option>
                    <option value="50" [selected]="queryParams && queryParams.perPage && queryParams.perPage == 50">50 items</option>
                    <option value="100" [selected]="queryParams && queryParams.perPage && queryParams.perPage == 100">100 items</option>
                    <option value="500" [selected]="queryParams && queryParams.perPage && queryParams.perPage == 500">500 items</option>
                  </select>
                </div>
              </li>
              <li class="list-inline-item f-small ml-xl-4" *ngIf="helperService.isSubscribed(profileData, 'plus-plan') || helperService.isSubscribed(profileData, 'premium-plan')">
                <div class="doller-box d-flex align-items-center justify-content-center">
                  <p class="sort m-0 d-flex align-items-center justify-content-center" (click)="listPshow = !listPshow"
                    [ngClass]="{'active': listPshow}">
                    <span [ngClass]="{'active': listPshow}">$</span>
                    <span [ngClass]="{'Noactive': !listPshow}">$</span>
                    <span [ngClass]="{'Noactive': !listPshow}" class="cross-line">/</span>
                  </p>
                </div>
              </li>
              <li class="list-inline-item f-small ml-xl-4">
                Sort By
              </li>
              <li class="list-inline-item">
                <div class="form-group mb-0">
                  <select class="form-control dr-list" id="sel1" (change)="sortBy($event)">
                    <option value="default" [selected]="queryParams && queryParams.sortBy == 'default'">Newest (default) </option>
                    <option value="price_low_to_high" [selected]="queryParams && queryParams.sortBy && queryParams.sortBy == 'price_low_to_high'">Price low to high</option>
                    <option value="price_high_to_low" [selected]="queryParams && queryParams.sortBy && queryParams.sortBy == 'price_high_to_low'">Price high to low</option>
                    <option value="brand" [selected]="queryParams && queryParams.sortBy && queryParams.sortBy == 'brand'" *ngIf="brand">Brand Name</option>
                  </select>
                </div>
              </li>

            </ul>
          </div>
        </div> -->

        <div class="tab-content list-reviews-tab-content listing-list">



          <div class="list-view" *ngIf="showFirstIcon">
            <app-preloader *ngIf="loadProducts"></app-preloader>
            <div class="row f-details">

              <ng-template [ngForOf]="products" let-product ngFor let-i="index">

                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-12 col-lg-4">
                      <a [routerLink]="['/', product.slug, product.sku]" class="img-wrap">
                        <img [src]="product.images | baseImage | imagePath" class="img-fluid mb-4 mx-auto d-block"
                          alt="img" />
                      </a>
                    </div>

                    <div class="col-md-12 col-lg-8">
                      <!-- <div class="product-top">
                    <div class="col-md-12 col-lg-6 col-sm-12 col-xs-12">

                    </div>
                    <div class="col-md-6 col-sm-12 col-xs-12 justify-content-end d-flex">
                      <span>List Price:</span>
                      <span class="ml-3">{{ product?.us_retail_price | currency: '$ ' }} /each</span>
                    </div>
                  </div>

                  <div class="product-top align-items-center">
                    <div class="col-md-6">
                      <h6 class="mb-0">Part No : {{ product.sku }}</h6>
                    </div>

                    <div class="col-md-6 justify-content-end d-flex increase-font2 p-0" *ngIf="product.clearance_corner">
                      <span class="bold">Sale Price:</span> <span class="ml-3 bold">{{ product?.price | currency: '$ ' }} </span>
                    </div>
                    <div class="col-md-6 justify-content-end d-flex font-reduce" *ngIf="product.discounted_price > 0" >
                      <span class="bold">Your Price:</span>
                      <span class="ml-3 bold">{{ product?.discounted_price | currency: '$ ' }} /each</span>
                    </div>
                  </div> -->



                      <div class="product-top row flex-row">
                        <div class="col-md-6 col-lg-6 col-sm-6 col-7">
                          <h3 class="bold mb-0">{{ product?.brand?.name }}</h3>
                          <h5 class="mb-3"> {{ product?.model?.name }} {{
                            product?.finish?.finish}}</h5>


                          <div class="product-info-box mt-4">
                            <div class="row">
                              <div class="col-md-6 col-sm-6 col-6 d-flex  pr-0">
                                Size:
                              </div>
                              <div class="col-md-6 col-sm-6 col-6">
                                {{ product.size }}
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6 col-sm-6 col-6 d-flex  pr-0">
                                Bolt Pattern:
                              </div>
                              <div class="col-md-6 col-sm-6 col-6">
                                {{ product.bolt_pattern }}
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6 col-sm-6 col-6 d-flex  pr-0">
                                Offset:
                              </div>
                              <div class="col-md-6 col-sm-6 col-6">
                                {{ product.offset }}
                              </div>
                            </div>

                            <div class="row d-none wheel_weight" [ngClass]="show_wheel_weight == true ? '' : 'd-none'">
                              <div class="col-md-6 col-sm-6 col-6 d-flex  pr-0">
                                Weight:
                              </div>
                              <div class="col-md-6 col-sm-6 col-6">
                                {{ product.weight == '' ? "--" : product.weight }}
                              </div>
                            </div>

                            <div class="row d-none hub_bore" [ngClass]="show_center_bore == true ? '' : 'd-none'">
                              <div class="col-md-6 col-sm-6 col-6 d-flex  pr-0">
                                Center Bore:
                              </div>
                              <div class="col-md-6 col-sm-6 col-6">
                                {{ product.hub_bore }}
                              </div>
                            </div>

                          </div>
                        </div>

                        <div
                          class="col-md-6 col-lg-6 col-sm-6 col-5 pl-0 flex-column increase-font2 d-flex justify-content-between">
                          <div class="product-top d-flex align-items-end flex-column top-end">
                            <div class="increase-font2">
                              <span class="mb-0 fw-sb">SKU : {{ product.sku }}</span>
                            </div>

                            <div class="increase-font2">
                              <span class="fw-sb">MSRP:</span>
                              <span class="ml-3 fw-sb">{{ product?.us_retail_price | currency:
                                product?.vendor?.currency:'symbol' }}</span>
                            </div>
                            <div class="increase-font2 p-0" *ngIf="product.clearance_corner">
                              <!--&& currentRoute == '/pre-order-deals'-->
                              <span class="bold">Sale Price:</span> <span class="ml-3 bold">{{ product?.price |
                                currency:
                                product?.vendor?.currency:'symbol' }}</span>
                            </div>
                            <div class="increase-font2 p-0 your_price_div"
                              *ngIf="product.discounted_price > 0 && listPshow && is_hide_cost == null">
                              <span class="bold ">Your Price:</span>
                              <span class="ml-3 bold">{{ product?.discounted_price | currency:
                                product?.vendor?.currency:'symbol' }}</span>
                            </div>
                          </div>
                          <div class="product-top d-flex align-items-end flex-column top-end">
                            <div class="increase-font2 p-0 " *ngIf="product.discounted_price > 0 && listPshow">
                              <span class="bold npc pb">Set of 4:</span>
                              <span class="ml-2 bold npc pb" *ngIf="is_hide_cost == null">{{
                                (product?.discounted_price*4) | currency: product?.vendor?.currency:'symbol' }}</span>
                              <span class="ml-2 bold npc pb" *ngIf="is_hide_cost != null">{{ (product?.price*4) |
                                currency: product?.vendor?.currency:'symbol' }}</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- <div class="product-top d-flex align-items-end flex-column top-end2">
                        <div class="mobileshow-set">
                          <div class="increase-font2 p-0 " *ngIf="product.discounted_price > 0 && listPshow">
                            <span class="bold npc pb">Set of 4:</span>
                            <span class="ml-3 bold npc pb" *ngIf="is_hide_cost == null">{{
                              (product?.discounted_price*4) | currency: product?.vendor?.currency:'symbol' }}</span>
                            <span class="ml-3 bold npc pb" *ngIf="is_hide_cost != null">{{ (product?.price*4) |
                              currency: product?.vendor?.currency:'symbol' }}</span>
                          </div>
                        </div>
                        
                      </div> -->

                      <div
                        class="col-md-12  mt-4 mb-3 d-flex align-items-center justify-content-between px-0 px-sm-2">

                        <div class="d-flex align-items-center">
                          <div class="custom-label new-quantity-box"
                            *ngIf="product.total_quantity > 0 || product.eta_quantity>0">
                            <div class="input-group custom-adder custom-adder-rw position-relative">
                              <input type="button" value="-" class="button-minus"
                                (click)="decrementQuantity(product.product_variant_id, product.in_stock_quantity, product.eta_quantity)" />

                              <input type="number" step="1" [min]="minQuantity"
                                [(ngModel)]="prodQty[product.product_variant_id]" name="quantity"
                                class="quantity-field" />

                              <input type="button" value="+" class="button-plus"
                                (click)="incrementQuantity(product.product_variant_id, product.in_stock_quantity, product.eta_quantity)">
                              <label class="f-light">Quantity</label>
                            </div>
                          </div>

                          <div class="">
                            <div class="details-btns">
                              <p class="mb-0 cp text-du max-text" *ngIf="product.in_stock_quantity>0"
                                data-toggle="modal"
                                (click)="getInventoryByProduct(product.id, product.product_variant_id)"
                                data-target="#stockModal">{{ product.in_stock_quantity }} in stock</p>
                              <p class="mb-0 cp text-du" *ngIf="product.in_stock_quantity<=0 && product.eta_quantity>0"
                                data-toggle="modal"
                                (click)="getInventoryByProduct(product.id, product.product_variant_id)"
                                data-target="#stockModal">{{ product.product_inventory[0].eta }}</p>
                              <p class="mb-0 red-alert text-du"
                                *ngIf="product.in_stock_quantity<=0 && product.eta_quantity<=0">Out of stock </p>
                            </div>
                          </div>
                        </div>

                        

                        <div class="d-flex align-items-center flex-column flex-sm-row details-btns">
                          
                          <a [routerLink]="['/', product.slug, product.sku]"
                            class="btn btn-02 f-large  addcart new-btn cart-detils text-uppercase">
                            <span>View Details</span>
                          </a>

                          <!-- <button type="button" class="btn btn-02 f-large  addcart ml-3 new-btn" *ngIf="!(productCartTotalQty[product.product_variant_id] === undefined || productCartTotalQty[product.product_variant_id] <= 0)" (click)="onAddToCart(product)"> -->
                          <button type="button" id="{{product.product_variant_id}}"
                            class="btn btn-02 f-large addcart ml-sm-3 mt-2 mt-sm-0 new-btn cart-btn text-uppercase"
                            *ngIf="product.total_quantity || product.eta_quantity>0" (click)="onAddToCart(product)">
                            <span>ADD TO CART</span>
                          </button>

                          <button type="button" class="btn btn-02 f-large  addcart ml-3 new-btn notify-btn cart-btn"
                            *ngIf="!product.total_quantity && !product.eta_quantity>0" (click)="notifyAddToCart(product)">
                            <span>Notify Me when Available</span>
                          </button>
                        </div>


                      </div>





                    </div>
                  </div>
                </div>

                <hr *ngIf="(i+1) % 1 == 0" style="width:96%; margin-bottom: 30px" />
              </ng-template>
            </div>
            <div class="row text-center" *ngIf="!loadMoreProducts && hasNextPage && !loadProducts && products.length">
              <div class="col-12">
                <button type="button" class="btn btn-02 f-large addcart ml-3 new-btn cart-btn text-white"
                  (click)="loadMore()">Load More</button>
              </div>
            </div>
            <app-preloader *ngIf="loadMoreProducts"></app-preloader>
            <app-not-found *ngIf="!products?.length && !loadProducts"></app-not-found>
          </div>

          <div class="grid-view" *ngIf="!showFirstIcon">
            <app-preloader *ngIf="loadProducts"></app-preloader>
            <div class="row f-details m-0">

              <ng-template [ngForOf]="products" let-product ngFor let-i="index">

                <div class="col-md-6 col-lg-6 col-xl-4 border-product">
                  <div class="row">
                    <div class="col-md-12">
                      <a [routerLink]="['/', product.slug, product.sku]" class="img-wrap">
                        <img [src]="product.images | baseImage | imagePath" class="img-fluid mx-auto d-block "
                          alt="img" />
                      </a>

                      <div class="product-top flex-column text-center">
                        <h5 class="mb-0">SKU : {{ product.sku }}</h5>
                        <h3 class="bold mb-2 mt-0">{{ product?.brand?.name }}</h3>
                        <h5 class=""> {{ product?.model?.name }} {{
                          product?.finish?.finish}}</h5>

                      </div>

                      <div class="d-flex align-items-center justify-content-center f-light mb-2">
                        {{ product.size }} | {{ product.bolt_pattern }} | {{ product.offset }}
                      </div>

                      <div class="d-flex flex-md-column flex-lg-row justify-content-between align-items-md-center mb-4 less-font">
                        <div class="increase-font2">
                          <span class="text-black">MSRP:</span>
                          <span class="ml-1 text-black">{{ product?.us_retail_price | currency:
                            product?.vendor?.currency:'symbol' }}</span>
                        </div>

                        <div class="increase-font2 p-0" *ngIf="is_hide_cost == null">
                          <span class="bold npc">Cost:</span>
                          <span class="ml-1 bold npc">{{ product?.discounted_price | currency:
                            product?.vendor?.currency:'symbol' }} </span>
                        </div>
                      </div>

                      <div class="d-flex justify-content-between align-items-center mb-2 flex-md-column flex-lg-row grid-last-section">

                        <p class="mb-0 cp text-du max-text" *ngIf="product.in_stock_quantity>0" data-toggle="modal"
                          (click)="getInventoryByProduct(product.id, product.product_variant_id)"
                          data-target="#stockModal">{{ product.in_stock_quantity }} in stock</p>
                        <p class="mb-0 cp text-du" *ngIf="product.in_stock_quantity<=0 && product.eta_quantity>0"
                          data-toggle="modal" (click)="getInventoryByProduct(product.id, product.product_variant_id)"
                          data-target="#stockModal">{{ product.product_inventory[0].eta }}</p>

                        <div class="custom-label new-quantity-box"
                          *ngIf="product.total_quantity > 0 || product.eta_quantity>0">
                          <div class="input-group custom-adder custom-adder-rw position-relative">
                            <input type="button" value="-" class="button-minus" (click)="decrementQuantity()"
                              (click)="decrementQuantity(product.product_variant_id, product.in_stock_quantity, product.eta_quantity)">
                            <input type="number" step="1" [min]="minQuantity"
                              [(ngModel)]="prodQty[product.product_variant_id]" name="quantity" class="quantity-field">
                            <input type="button" value="+" class="button-plus"
                              (click)="incrementQuantity(product.product_variant_id, product.in_stock_quantity, product.eta_quantity)">
                            <label class="f-light">Quantity</label>
                          </div>
                        </div>

                        <button type="button" class="btn btn-02 f-large  addcart  new-btn cart-btn text-uppercase"
                          *ngIf="productQtyCheck(product.product_inventory) > 0 || product.eta_quantity>0"
                          (click)="onAddToCart(product)">
                          <span>ADD TO CART</span>
                        </button>
                      </div>


                      <div class="d-flex flex-column align-items-center mb-2 gap-2">


                        <p class="mb-0 red-alert text-du mb-2"
                          *ngIf="product.in_stock_quantity<=0 && product.eta_quantity<=0">Out of stock </p>





                        <button type="button"
                          class="btn btn-02 f-large  addcart new-btn notify-btn d-flex cart-btn text-uppercase"
                          *ngIf="!product.total_quantity && !product.eta_quantity>0" (click)="notifyAddToCart(product)">
                          <span>Notify Me when Available</span>
                        </button>
                      </div>
                    </div>

                    <div class="col-md-12">




                      <!-- <div class="d-flex flex-wrap stock-section">
                      <div class="col-12 col-md-12 col-lg-12 col-xl-12 mb-3"
                        *ngFor="let invt of product.product_inventory">

                        <div class="row align-items-center" *ngIf="!invt.eta">
                          <div class="col-md-5">
                            <p class="mb-0 mr-2">{{invt.warehouse?.warehouse_name}} - {{ invt.quantity }} in stock</p>
                          </div>
                          <div class="col-md-7 d-flex align-items-center pb-sm-0 pt-2">
                            <input autocomplete="off" type="number" step="1" min="0" name="quantity"
                              class="search-inputs-bold input-details mr-2"
                              [(ngModel)]="prodQty[product.product_variant_id+'_'+invt.warehouse?.id]"
                              (ngModelChange)="addEditQty( invt.warehouse.code, invt.warehouse.id, invt.quantity,  product.product_variant_id,  product.product_inventory, 0, $event)" />
                          </div>
                        </div>

                        <div class="row align-items-center" *ngIf="invt.eta">
                          <div class="col-md-5">
                            <p class="mb-0" *ngIf="invt.quantity>0">{{invt.warehouse?.warehouse_name}} - {{
                              invt.quantity }} in stock</p>
                            <p class="mb-0" *ngIf="invt.quantity<=0">{{invt.warehouse?.warehouse_name}} - Out of stock
                            </p>
                          </div>

                          <div class="col-md-7 d-flex align-items-center pb-sm-0 pt-2">
                            <input autocomplete="off" type="number" step="1" min="0" name="quantity"
                              class="search-inputs-bold input-details mr-2"
                              [(ngModel)]="prodQty[product.product_variant_id+'_'+invt.warehouse?.id]"
                              (ngModelChange)="addEditQty( invt.warehouse.code, invt.warehouse.id, invt.quantity,  product.product_variant_id,  product.product_inventory, invt.eta_qty, $event)" />
                            <p class="mb-0 text-left">{{invt.eta_qty}} pcs {{invt.eta}}</p>
                          </div>
                        </div>
                      </div>
                    </div> -->



                      <!-- <div class="col-md-12 d-flex justify-content-end mb-3">

                      <a [routerLink]="['/', product.slug, product.sku]"
                        class="btn btn-02 f-large  addcart new-btn cart-detils text-uppercase">
                        <span>View Details</span>
                      </a>

                      <button type="button" class="btn btn-02 f-large  addcart ml-3 new-btn cart-btn text-uppercase"
                        *ngIf="productQtyCheck(product.product_inventory) > 0" (click)="onAddToCart(product)">
                        <span>ADD TO CART</span>
                      </button>

                      <button type="button" class="btn btn-02 f-large  addcart ml-3 new-btn "
                        *ngIf="productQtyCheck(product.product_inventory) <= 0" (click)="notifyAddToCart(product)">
                        <span>Notify Me when Available</span>
                      </button>


                    </div> -->
                    </div>
                  </div>
                </div>

                <!-- <hr *ngIf="(i+1) % 3 == 0" style="width:96%; margin-bottom: 30px" /> -->
              </ng-template>
            </div>
            <div class="row text-center mt-4"
              *ngIf="!loadMoreProducts && hasNextPage && !loadProducts && products.length">
              <div class="col-12">
                <button type="button" class="btn btn-02 f-large addcart ml-3 new-btn cart-btn text-uppercase text-white"
                  (click)="loadMore()">Load More</button>
              </div>
            </div>
            <app-preloader *ngIf="loadMoreProducts"></app-preloader>
            <app-not-found *ngIf="!products?.length && !loadProducts"></app-not-found>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--  -->






<button class="btn btn-lg btn-outline-primary" id="auto_trigger" style="display: none;"
  (click)="openModal(detailpagemodal)">Open Add On Modal</button>

<ng-template #detailpagemodal let-modal>
  <div class="modal-header p-0 fntres">
    <div class="container-lg">

      <div class="row">
        <button type="button" class="close modal-close-btn" aria-label="Close"
              (click)="modal.dismiss('Cross click');resetProdCustomizationProperties()">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M20.7457 3.32851C20.3552 2.93798 19.722 2.93798 19.3315 3.32851L12.0371 10.6229L4.74275 3.32851C4.35223 2.93798 3.71906 2.93798 3.32854 3.32851C2.93801 3.71903 2.93801 4.3522 3.32854 4.74272L10.6229 12.0371L3.32856 19.3314C2.93803 19.722 2.93803 20.3551 3.32856 20.7457C3.71908 21.1362 4.35225 21.1362 4.74277 20.7457L12.0371 13.4513L19.3315 20.7457C19.722 21.1362 20.3552 21.1362 20.7457 20.7457C21.1362 20.3551 21.1362 19.722 20.7457 19.3315L13.4513 12.0371L20.7457 4.74272C21.1362 4.3522 21.1362 3.71903 20.7457 3.32851Z"
                    fill="#0F0F0F"></path>
                </g>
              </svg>
            </button>
        <div class="col-md-6">
          <!-- success message here -->
          <div class="cart-left">
            <!-- <div class="alert alert-success" role="alert" *ngIf="successMessage">
                <svg viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <rect width="16" height="16" id="icon-bound" fill="none"></rect> <path d="M0,9.014L1.414,7.6L5.004,11.189L14.593,1.6L16.007,3.014L5.003,14.017L0,9.014Z"></path> </g></svg>
                  {{successMessage}}
              </div> -->
            <div class="alert alert-success cartpopupmessage">
              <i class="fa fa-check"></i>
              Items Successfully Added To Cart
            </div>
            <div class="cart-product-row">
              <div class="position-relative">
                <span class="tip">{{ productCartTotalQty[productAddedToCart.product_variant_id] }}</span>
                <img [src]="productAddedToCart.images | baseImage | imagePath" alt="Product" />
              </div>
              <div class="cart-left-title">
                <h4>{{productAddedToCart.product_full_name}}</h4>
                <div class="cart-product-row-inner">

                  <p class="mb-0">Part No: {{ productAddedToCart.sku }}</p>
                  <p class="mb-0">Size: {{ productAddedToCart.size }}</p>
                  <p class="mb-0">Bolt Pattern: {{ productAddedToCart.bolt_pattern }}</p>
                  <p class="mb-0">Offset: {{ productAddedToCart.offset }}</p>
                  <strong *ngIf="is_hide_cost == null">{{ productAddedToCart?.discounted_price | currency:
                    productAddedToCart?.vendor?.currency:'symbol' }} / Each</strong>
                  <strong *ngIf="is_hide_cost != null">{{ productAddedToCart?.price | currency:
                    productAddedToCart?.vendor?.currency:'symbol' }} / Each</strong>
                </div>

                <div class="form-group mt-2" *ngIf="isProductCustomization">
                  <input class="form-control" type="text" [(ngModel)]="vehicle_year_make_model"
                    placeholder="Enter Vehicle year make model to ensure fitment" />
                  <span *ngIf="p_customization_submitted">
                    <span class="error"
                      *ngIf="(bolt_pattern == 'recommended' || offset == 'recommended') && !vehicle_year_make_model">This
                      field is required</span>
                  </span>
                </div>
                <div class="form-group mt-2" *ngIf="!isProductCustomization">
                  <input class="form-control" type="text" [(ngModel)]="vehicle_year_make_model"
                    placeholder="Enter Vehicle year make model to ensure fitment" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 bl-cart">


          <div class="cart-right">
            
            <h5 class="modal-title text-center" id="modal-basic-title"
              *ngIf="!isProductCustomization && is_hide_cost != null">Your current cart
              value: {{ productAddedToCart.price | currency: '$ '}}</h5>
            <h5 class="modal-title text-center" id="modal-basic-title"
              *ngIf="!isProductCustomization && is_hide_cost == null">Your current cart
              value: {{ cartResp.total | currency: '$ '}}</h5>
            <button type="button" class="btn btn-02 mb-2" aria-label="Close" (click)="closeModalAndRedirectCart(false)"
              *ngIf="!isProductCustomization">Continue Shopping</button>
            <button type="button" class="btn btn-04" *ngIf="!isProductCustomization"
              (click)="closeModalAndRedirectCart(true)">Checkout</button>
            <div class="cart-right-row" *ngIf="isProductCustomization">
              <div class="cart-right-row-inner"
                *ngIf="cartResp.product_customizations[getFirstKey(cartResp.product_customizations)].is_custom_finish">
                <span>Custom Finish:</span>
                <div>
                  <select class="form-control custom-finish-control" [(ngModel)]="custom_finish"
                    (change)="onCustomFinishSelect($event)">
                    <option value="">Choose Finish</option>
                    <option *ngFor="let p_customization of cartResp.product_customizations[getFirstKey(cartResp.product_customizations)].product_customizations"
                      [value]="p_customization.id">{{ p_customization.finish_name }} (+ {{p_customization.cost |
                      currency: '$' }})
                    </option>
                  </select>
                  <span *ngIf="p_customization_submitted">
                    <span class="error" *ngIf="!custom_finish">This field is required</span>
                  </span>
                </div>
              </div>
              <div class="cart-right-row-inner" *ngIf="cartResp.product_customizations[getFirstKey(cartResp.product_customizations)].bolt_patterns && cartResp.product_customizations[getFirstKey(cartResp.product_customizations)].bolt_patterns.length>0">
                <span>Bolt Pattern:</span>
                <select class="form-control" [(ngModel)]="bolt_pattern">
                  <option value="recommended">Recommended</option>
                  <option *ngFor="let bolt_battern of cartResp.product_customizations[getFirstKey(cartResp.product_customizations)].bolt_patterns" [value]="bolt_battern">{{ bolt_battern }}
                  </option>
                </select>
              </div>

              <div class="cart-right-row-inner"
                *ngIf="cartResp.product_customizations[getFirstKey(cartResp.product_customizations)].is_offset_drilling && offsetDropdownValues && offsetDropdownValues.length>0">
                <span>Offset:</span>
                <select class="form-control" [(ngModel)]="offset">
                  <option value="recommended">Recommended</option>
                  <option *ngFor="let offset of offsetDropdownValues" [value]="offset">{{ offset }}</option>
                </select>
              </div>


            </div>
            <div class="mt-4 d-inline-flex justify-content-end" *ngIf="isProductCustomization">
              <button type="button" class="btn btn-02 f-large addcart new-btn ml-auto"
                (click)="addToCartFromProductCustomizationPopup(productAddedToCart)"><span>ADD TO CART</span></button>
            </div>

          </div>
        </div>
      </div>


    </div>

  </div>
  <div class="modal-body" [hidden]="prodAddons.length <= 0">
    <div class="container">
      <app-add-ons [addOns]="prodAddons" [is_hide_cost]="is_hide_cost" [cartItems]="cartItems" [modal]="modal"
        [selectedWarehouseId]="productAddedToCart?.product_inventory[0]?.warehouse_id"></app-add-ons>
    </div>
  </div>
</ng-template>



<div class="modal fade stock-modal" id="stockModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h5 class="modal-title" id="exampleModalLabel">Inventory</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body border-0">
        <div class="d-flex flex-row align-items-center justify-content-center inventory_loader">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <span>&nbsp;&nbsp;Fetching Data ...</span>
        </div>
        <div class="table-responsive inventory_table">
          <table class="table cart-table">
            <thead>
              <tr>
                <th>Warehouse</th>
                <th>Quantity</th>
                <th>Ship From</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let inventory of inventoryData; let i = index">
                <tr *ngIf="inventory.quantity>0">
                  <td>{{inventory.warehouse_name}}</td>
                  <td>
                    <span>{{ inventory.quantity }}</span>
                  </td>
                  <td>
                    <input type="radio" name="stock" [checked]="i === 0"
                      (change)="setWarehouse(clickedProductID, inventory.id, false)" />
                  </td>
                </tr>
                <tr *ngIf="inventory.eta">
                  <td>{{inventory.warehouse_name}}</td>
                  <td>
                    <span>{{ inventory.eta_qty }} {{
                      inventory.eta}}</span>
                  </td>
                  <td>
                    <input type="radio" name="stock" [checked]="i === 0 && inventory.quantity == 0"
                      (change)="setWarehouse(clickedProductID, inventory.id, true)" />
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</div>


<div id="overlay" class="overlay" *ngIf="isDownloding">
  <div class="text-white text-center d-flex flex-column justify-content-center align-items-center">
    <h1>Downloding Products ...</h1>
    <img src="assets/img/new-loader.png" id="voyager-loader">
  </div>
</div>